import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useFlowState = (storageKey, requiredKeys, fallbackRoute) => {
    const location = useLocation();
    const navigate = useNavigate();

    const stored = useMemo(() => {
        try {
            return JSON.parse(sessionStorage.getItem(storageKey)) || {};
        } catch {
            return {};
        }
    }, [storageKey]);

    const data = { ...stored, ...(location.state || {}) };
    const isValid = requiredKeys.every((key) => data[key]);

    useEffect(() => {
        if (isValid) {
            sessionStorage.setItem(storageKey, JSON.stringify(data));
        } else {
            navigate(fallbackRoute, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isValid]);

    const clear = () => sessionStorage.removeItem(storageKey);

    return { ...data, isValid, clear };
};

export default useFlowState;
